import { render, staticRenderFns } from "./swipebox.vue?vue&type=template&id=f2a7a986&scoped=true"
import script from "./swipebox.vue?vue&type=script&lang=js"
export * from "./swipebox.vue?vue&type=script&lang=js"
import style0 from "./swipebox.vue?vue&type=style&index=0&id=f2a7a986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7a986",
  null
  
)

export default component.exports